import {
  createAsyncThunk,
  createReducer,
  isFulfilled,
  isPending,
  isRejected,
} from "@reduxjs/toolkit";
import { Product } from "../../sdk/@types";
import ProductService from "../../sdk/services/ProductService";

interface ProductState {
  product: Product.Product | null;
  list: Product.Product[];
  fetching: boolean;
}

const initialState: ProductState = {
  product: null,
  list: [],
  fetching: false,
};

export const getProducts = createAsyncThunk(
  "product/getProducts",
  async () => await ProductService.getAll(),
);

export default createReducer(initialState, (builder) => {
  const success = isFulfilled(getProducts);
  const error = isRejected(getProducts);
  const loading = isPending(getProducts);

  builder
    .addCase(getProducts.fulfilled, (state, action) => {
      state.list = action.payload;
    })
    .addMatcher(success, (state) => {
      state.fetching = false;
    })
    .addMatcher(error, (state) => {
      state.fetching = false;
    })
    .addMatcher(loading, (state) => {
      state.fetching = true;
    });
});
